import { components } from "../types/openapi";
import { CurrencyType, NetworkType } from "./contracts";

export type TBidDto = components["schemas"]["RequestCardCustomerDto"] &
  components["schemas"]["RequestGridDto"] &
  components["schemas"]["RequestGridLpDto"];
export type BidList = components["schemas"]["PendingActionsCriteria"];
export type BidEntity = TBidDto & {
  currencyOperationCode?: string;
  lpFee: number;
  lpFeeRub?: number;
};
export type BidGridDto = TBidDto;
export type BidEntityByContract = components["schemas"]["RequestByContractGridDto"];
export type ContractDtoOnBid = components["schemas"]["RequestCardCustomerDto"]["contract"];
export type BankStatementPaymentType = "MAIN" | "FEE_CUSTOMER" | "FEE_LP";
export type BankStatement = components["schemas"]["AccountDetailsItem"] & {
  paymentType: BankStatementPaymentType;
  rubAmount: number;
};
export type CreateBidType = components["schemas"]["CreateRequestRequest"] & {
  amount?: number;
  currency?: CurrencyType;
  network?: NetworkType;
  destinationWallet?: string;
  fiatCurrency?: string;
  currencyOperationCode: string;
};
export type SenderAmountDto = components["schemas"]["SenderAmountDto"];
export type AgentProposalRequest = components["schemas"]["RequestAgentProposal"];
export type RequestType = components["schemas"]["RequestCardCustomerDto"]["type"];
export type BidTransactionGridDto = components["schemas"]["RequestTxGridDto"];
export type BidWalletCheckGridDto = components["schemas"]["RequestWalletCheckGridDto"];
export type FeeDetailDto = components["schemas"]["RequestCardFeeDetailDto"] & {
  discountThreshold?: number;
};
export type FeeDetailRole = FeeDetailDto["role"];

export const BID_REQUEST_TYPE_ENUM: Record<RequestType, RequestType> = {
  REQUEST_WITH_AGENT: "REQUEST_WITH_AGENT",
  REQUEST_WITHOUT_AGENT: "REQUEST_WITHOUT_AGENT",
};
export enum FILTERS_KEY_ENUM {
  ONLY_MY_FUNDS = "onlyMyFunds",
  POSITIVE_BALANCES = "positiveBalances",
}

export enum BID_DRAFT_ACTION_MODE {
  DECLINE = "decline",
  RETURN_TO_DRAFT = "return-to-draft",
}

export enum MODE_TYPE {
  CUSTOMER = "CUSTOMER",
  LIQUIDITY_PROVIDER = "LIQUIDITY_PROVIDER",
}
